import * as React from 'react'
import {Droppable} from 'react-beautiful-dnd';
import {getUIFields, IUIFieldDefinition} from '../common/common';
import {DragWrapper} from '../common/dnd';
import {IContextProvider} from '../../uxp';
import {Simulate} from "react-dom/test-utils";
import load = Simulate.load;
import {Loading} from "uxp/components";

export interface ICardWidget {
    ID: string
    Name: string
    Key: string
    WidgetID: string
    Template: IWidgetTemplateData
    Description: string
    Icon: string
    __rowid__: string
}

export interface IWidgetTemplateData {
    __template__: IWidgetTemplate
    uiProps: any
}

export interface IWidgetTemplate {
    type: string
    id: string
    layout: any
    zoom: number
    locked: boolean
}

interface IWidgetPanelProps {
    uxpContext: IContextProvider
}

const APPROVED_CARD_TEMPLATES = [
    'box-chart',
    'donut-chart',
    'two-value-widget',
    'line-chart',
    'bar-line-chart',
    'radial-gauge-2',
]

const WidgetPanel: React.FunctionComponent<IWidgetPanelProps> = (props) => {

    let [widgets, setWidgets] = React.useState<ICardWidget[]>(null)
    let [loading, setLoading] = React.useState<boolean>(false)

    async function getApprovedWidgets() {
        try {
            let widgetTemplates = await props.uxpContext.executeService('UXP', 'CardTemplate:Search', {max: 1000}, {json: true})

            widgetTemplates = (widgetTemplates || [])
                .map((wid: any) => ({...wid, Template: JSON.parse(wid.Template)}))
                .filter((w: any) => APPROVED_CARD_TEMPLATES.includes(w.Template?.__template__?.type))

            return widgetTemplates;
        
        } catch (e) {
            console.error('Unable to get widgets ', e);
        }
    }

    React.useEffect(() => console.log("Card Widget Templates", widgets), [widgets])

    React.useEffect(() => {
        setLoading(true);

        getApprovedWidgets()
            .then((ws) => setWidgets(ws))
            .finally(() => setLoading(false))
    }, [])

    if(loading) {
        return <Loading/>
    }

    return <div className='wd-widget-panel'>
        <div className="not-selected">Drag and drop an item to highlighted are and click on it to configure the
            properties
        </div>
        {
            (widgets?.length > 0) ? (
                    <Droppable droppableId="widgets" isDropDisabled={true}>
                        {
                            (provided, snapshot) => {
                                return (
                                    <>
                                        <div className='wd-widget-panel-widget-list' ref={provided.innerRef}>
                                            {
                                                widgets.map((w, index) => {
                                                    return <WidgetWrapper index={index} widget={w}/>
                                                })
                                            }
                                        </div>
                                        {provided.placeholder}
                                    </>
                                )
                            }
                        }
                    </Droppable>
                )
                :
                (
                    <div className="no-widgets">No widgets available</div>
                )
        }

    </div>
}

const WidgetWrapper: React.FunctionComponent<{ widget: ICardWidget, index: number }> = (props) => {
    return (

        <DragWrapper type='widget' data={props.widget} index={props.index}>
            {
                (provided, snapshot) => {
                    return <>
                        <div className='wd-widget-item' {...provided.draggableProps} {...provided.dragHandleProps}
                             ref={provided.innerRef}>
                            <div className='wd-widget-title'>{props.widget.Name}</div>
                            {/*<div className='wd-widget-description'>{props.widget.Description}</div>*/}
                        </div>
                        {
                            snapshot.isDragging && <div className='wd-widget-item dragging'>
                                <div className='wd-widget-title'>{props.widget.Name}</div>
                                {/*<div className='wd-widget-description'>{props.widget.Description}</div>*/}
                            </div>
                        }
                    </>;
                }
            }

        </DragWrapper>

    )
};

export default WidgetPanel